module.exports = __webpack_public_path__ + "static/media/Customer.f5bbe48d.svg";